import { useEffect } from 'react';
import { IWhatIfLang } from 'src/core/repo/whatif/types';
import { useGetWhatIfLangs } from 'src/core/repo/whatif/useCase';
import styles from './selectLanguage.module.scss';
import { GoChevronRight } from 'react-icons/go';

interface Props {
  onSelectLanguage: (languageId: IWhatIfLang) => void;
  theme: 'night' | 'day';
  searchParams: URLSearchParams;
}

const SelectLanguage = ({ onSelectLanguage, theme, searchParams }: Props) => {
  const getWhatIfLangMutation = useGetWhatIfLangs();
  const languages: IWhatIfLang[] = getWhatIfLangMutation.data ?? [];
  const selectedLanguage = searchParams.get('lang');

  const subTitle =
    selectedLanguage === 'Persian'
      ? 'لطفاً زبان مورد نظرتون رو انتخاب کنید تا بهترین تجربه رو در اختیارتون بذاریم'
      : 'Please select your preferred language so we can provide you with the best experience';

  useEffect(() => {
    getWhatIfLangMutation.mutate();
  }, []);

  return (
    <div className={styles.container}>
      <div>
        <div className={styles.description_wrapper}>
          <h1 style={{ color: theme === 'day' ? '#000' : '#fff' }}>
            {selectedLanguage === 'Persian'
              ? 'زبان مورد نظر را انتخاب کنید'
              : 'Select language'}
          </h1>
          <p style={{ color: theme === 'day' ? '#333' : '#fff' }}>{subTitle}</p>
        </div>

        <div className={styles.options}>
          {languages.map((item, idx) => (
            <div
              key={idx}
              className={styles.option}
              onClick={() => onSelectLanguage(item)}>
              <h3>{item.Lang}</h3>
              <div className={styles.option_action}>
                <GoChevronRight
                  className={styles.chevron_right}
                  size={24}
                  color={'#292D32'}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SelectLanguage;
